__turbopack_context__.v({
  "className": "ubuntu_41069a2d-module__r5AKEa__className",
  "variable": "ubuntu_41069a2d-module__r5AKEa__variable",
});
